// ===== Packages =====

import React, {
    useEffect,
    useRef,
}                                   from 'react';

interface Props {
    onClick: (e: MouseEvent | TouchEvent) => void,
    children: React.ReactNode,
}

function OutsideClickHandler({
    onClick,
    children,
}: Props): JSX.Element {
    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handlePointerEvent = (event: MouseEvent | TouchEvent): void => {
            const currentContainer = containerRef.current;
            const targetNode = event.target as Node | null;

            if (
                !currentContainer
                || !targetNode
                || currentContainer.contains(targetNode)
            ) {
                return;
            }

            onClick(event);
        };

        document.addEventListener('mousedown', handlePointerEvent);
        document.addEventListener('touchstart', handlePointerEvent);

        return () => {
            document.removeEventListener('mousedown', handlePointerEvent);
            document.removeEventListener('touchstart', handlePointerEvent);
        };
    }, [onClick]);

    return (
        <div
            ref={containerRef}
            style={{ display: 'contents' }}
        >
            {children}
        </div>
    );
}

export default OutsideClickHandler;
